import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Table, Tag, Menu, Icon, Dropdown, Select, Tooltip, Button, Modal, message, Popover, Badge } from 'antd';
import get from 'lodash/get';
import { MailFilled } from '@ant-design/icons';
import { FaWhatsapp } from 'react-icons/fa';
import { AiFillMail } from 'react-icons/ai';

import moment from 'moment';
import 'moment/locale/pt-br';

import * as malhaFinaActions from '~/containers/MalhaFina/actions';
import { capitalizeFormatter, identificationNumberFormatter } from '~/utils/formatters'
import { getAllMonths } from './methods/getAllMonths';
import { getIRPFMonths } from './methods/getIRPFMonths';
import { ModuleHeader } from '~/components/ModuleHeader';
import { CellButton, CellButtonsWrapper, HeaderContainer, HeaderLeftContent } from './styles';
import { EmailsLogsModal } from './components/EmailsLogsModal';
import { getDefaultPaginationConfig } from '~/utils/get-default-pagination-config';
import { STORAGE } from '~/constants/storage.constants';
import Search from '~/_shared/components/Search';
import FilterPillsBar from '~/_shared/components/FilterPillsBar';
import RestoredFiltersNotice from '~/_shared/components/RestoredFiltersNotice';
import { countActiveMalhaFinaFilters, getMalhaFinaYearOptions } from './helpers';

const { Column } = Table;
const { Option } = Select;

function getBackgroundColorCell(status){
  if(status !== null){
    if(status === 1){
      return '#1B76FF';
    }else if(status === 2){
      return '#FF0000';
    }else{
      return '#36BD2C';
    }
  }else{
    return '#bfbfbf';
  }
}

function getWhatsappIconColor(isWhatsappSent) {
  return isWhatsappSent ? '#1B76FF' : '#FFF';
}

function getEmailIconColor(isEmailSent, isEmailViewed) {
  if (isEmailViewed) {
    return '#36BD2C';
  }

  if (isEmailSent) {
    return '#1B76FF';
  }

  return '#FFF';
}

const List = (props) => {

  // Applied filters live in the screen (usePersistedFilters, one entry per
  // department), which reloads the list whenever the year changes.
  var persisted = props.persisted;
  var defaults = persisted.defaults;
  var setApplied = persisted.setFilters;
  var year = props.applied.year;
  var search = props.applied.search;
  var setYear = function(value) { setApplied({ year: value }); };
  var setSearch = function(value) { setApplied({ search: value }); };
  const [selectedRows, setSelectedRows] = useState([]);
  const [isSendingEmailsInBatch, setIsSendingEmailsInBatch] = useState(false);
  const [emailsLogsModal, setEmailsLogsModal] = useState({
    isOpen: false,
    data: null
  });

  const {
    changeStatus,
    deleteRegister,
    deleteAllRegisterOfMonth,
    isLoading,
    sendWhatsapp,
    sendEmail,
    sendEmailsInBatch
  } = props;

  const { department } = props.match.params;

  const data = props.data[department];

  let filtered = (data !== null)? data.filter((str) => {

    if(str.name.toLowerCase().indexOf(search.toLowerCase()) >= 0){
      return true;
    }

    if(str.cod.toString().toLowerCase().indexOf(search.toLowerCase()) >= 0){
      return true;
    }

    // if(str.identification_number.toLowerCase().indexOf(search.toLowerCase()) >= 0){
    //   return true;
    // }

    return false;
  }): [];

  const allMonths = getAllMonths(year);
  const IRPFMonths = getIRPFMonths(year);

  const months = department !== 'IRPF' ? allMonths : IRPFMonths;

  useEffect(() => {
    setSelectedRows([]);
  }, [department]);

  const openEmailsLogsModal = (data) => {
    setEmailsLogsModal({
      isOpen: true,
      data
    });
  };

  const closeEmailsLogsModal = () => {
    setEmailsLogsModal({
      isOpen: false,
      data: null,
    });
  };

  function handleDelete({
    id,
    monthBase,
    monthYear
  }) {
    Modal.confirm({
      title: 'Você realmente deseja remover este registro?',
      content: 'Esta ação não poderá ser desfeita.',
      okText: 'Sim',
      okType: 'danger',
      cancelText: 'Cancelar',
      onOk: () => {
        deleteRegister(department, {
          id,
          month_base: monthBase,
          year: monthYear
        });
      },
    });
  }

  function handleDeleteMonth(month, index) {
    const hasSomeFilledRegister = filtered.some((item) => {
      const monthIndex = department !== 'IRPF' ? Number(month.base) - 1 : index;
      return item[`date${monthIndex}`] !== null;
    });

    if (hasSomeFilledRegister) {
      Modal.confirm({
        title: `Você realmente deseja remover todos os registros do mês de ${month.fullText}?`,
        content: 'Esta ação não poderá ser desfeita.',
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Cancelar',
        onOk: () => {
          deleteAllRegisterOfMonth(department, {
            month_base: month.base,
            year: month.year
          })
        },
      });
    } else {
      message.warning('Não existem registros nesse mês para serem removidos.')
    }
  }

  async function handleSendEmailInBatch() {
    setIsSendingEmailsInBatch(true);
    try {
      await sendEmailsInBatch({
        department,
        year,
        month: moment().format('MM'),
        ids: selectedRows.map(({ id }) => id)
      });
    } catch (error) {
      console.log(error);
    } finally {
      setIsSendingEmailsInBatch(false);
    }
  }

  async function handleOpenWhatsapp({ record, month, isWhatsappSent }) {
    const { phone, id } = record;

    if (!phone) {
      return message.warning('O cliente não possui um telefone cadastrado!');
    }

    if (!isWhatsappSent) {
      await sendWhatsapp(
        department,
        {
          id,
          month_base: month.base,
          year: month.year
        }
      );
    }

    const whatsappMessage = `Encontramos pendências em âmbito ${department}, entre em contato para regularizar.`;
    const whatsappUrl = `https://api.whatsapp.com/send?phone=55${phone}&text=${whatsappMessage}`;
    window.open(whatsappUrl, "_blank").focus();
  }

  async function handleSendEmail({ record, month, isEmailSent }) {
    const { email, id } = record;

    if (!email) {
      return message.warning('O cliente não possui um e-mail cadastrado!');
    }

    if (isEmailSent) {
      openEmailsLogsModal({
        id,
        month_base: month.base,
        year: month.year
      });
    } else {
      await sendEmail(
        department,
        {
          id,
          month_base: month.base,
          year: month.year
        }
      );
    }
  }

  var isDefaultYear = year === defaults.year;
  var filterCount = countActiveMalhaFinaFilters(props.applied, defaults);

  var filterPills = [];
  filterPills.push({
    key: 'year',
    label: 'Ano: ' + year,
    color: '#1890ff',
    icon: 'calendar',
    onRemove: !isDefaultYear ? function() { setYear(defaults.year); } : undefined,
  });
  if (search) {
    filterPills.push({
      key: 'search',
      label: 'Busca: ' + search,
      color: '#722ed1',
      icon: 'search',
      onRemove: function() { setSearch(''); },
    });
  }

  var handleClearAllFilters = persisted.resetFilters;

  var restoredSummary = filterPills
    .filter(function(pill) { return !!pill.onRemove; })
    .map(function(pill) { return pill.label; })
    .join(' · ');

  return (
    <div>
        <ModuleHeader
              breadcrumbs={['Dep. Societário', 'Malha fiscal', capitalizeFormatter(department)]}
              title="Malha fina"
              search={
                <Search
                  value={search}
                  placeholder="Pesquisar cliente"
                  onChange={function(e) { setSearch(e.target.value); }}
                />
              }
              center={
                <>
                <Popover
                  trigger="click"
                  placement="bottomRight"
                  content={
                    <div style={{ width: 260 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                        <span style={{ fontSize: 15, fontWeight: 600, color: '#262626' }}>Filtros</span>
                        {!persisted.isDefault && (
                          <a
                            style={{ fontSize: 12, color: '#f5222d' }}
                            onClick={handleClearAllFilters}
                          >
                            Limpar tudo
                          </a>
                        )}
                      </div>
                      <div>
                        <div style={{ fontSize: 11, color: '#8c8c8c', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Ano</div>
                        <Select
                          style={{ width: '100%' }}
                          value={year}
                          placeholder="Selecione um ano"
                          onChange={function(value) { setYear(value); }}
                        >
                          {getMalhaFinaYearOptions(moment().year()).map(function(row) {
                            return <Option value={row} key={row}>{row}</Option>;
                          })}
                        </Select>
                      </div>
                    </div>
                  }
                >
                  <Badge
                    count={filterCount}
                    offset={[-4, 0]}
                    style={{ backgroundColor: '#722ed1' }}
                  >
                    <Button
                      icon="bars"
                      style={{ borderRadius: 8 }}
                    >
                      Filtros
                    </Button>
                  </Badge>
                </Popover>
                <Button
                  disabled={selectedRows.length === 0 || isSendingEmailsInBatch}
                  type="primary"
                  style={{ borderRadius: 8 }}
                  icon="mail"
                  onClick={handleSendEmailInBatch}
                >
                  Enviar e-mails
                </Button>
                </>
              }
              advanced={filterPills.length > 0 ? (
                <FilterPillsBar
                  pills={filterPills}
                  onClearAll={!persisted.isDefault ? handleClearAllFilters : undefined}
                />
              ) : null}
        />
        <RestoredFiltersNotice
          visible={persisted.wasRestored}
          summary={restoredSummary}
          onReset={handleClearAllFilters}
          onDismiss={persisted.dismissRestored}
        />
        <div className="table-clabs">
          <Table
            dataSource={filtered}
            rowKey="id"
            loading={isLoading}
            rowClassName="row-clabs-grid"
            rowSelection={{
              selectedRowKeys: selectedRows.map(({ id }) => id),
              onChange: (_, rows) => {
                setSelectedRows(rows);
              },
              getCheckboxProps: (record) => {
                const currentMonth = Number(moment().format('MM')) - 1;
                const isEmailSent = record[`is_email_sent${currentMonth}`] === 1;
                const hasPendencyInCurrentMonth = record[`date${currentMonth}`] === 2;
                return {
                  disabled: !hasPendencyInCurrentMonth || isEmailSent
                }
              }
            }}
            pagination={getDefaultPaginationConfig({
              storageKey: STORAGE.defaultPageSize.malhaFina, 
              defaultPageSize: 1000
            })}
            bordered={true}
            scroll={{ x: true, y: 'calc(100vh - 330px)' }}
          >
            <Column
                title="Cód"
                dataIndex="cod"
                key="cod"
                width={150}
                render={cod => <Tag key={cod}>{cod}</Tag>}
                sorter={(a, b) => a.cod && a.cod.localeCompare(b.cod)}
              />
              <Column
                  title="Cliente"
                  dataIndex="name"
                  key="name"
                  width={450}
                  sorter={(a, b) => a.name && a.name.localeCompare(b.name)}
              />
              {department !== 'IRPF' && (
                <Column
                  title="CNPJ"
                  dataIndex="identification_number"
                  key="identification_number"
                  width={200}
                  render={(identificationNumber) => identificationNumberFormatter(identificationNumber)}
                />
              )}
              {department !== 'IRPF' && (
                <Column
                  title="Link"
                  dataIndex="link"
                  align="center"
                  key="link"
                  width={80}
                  render={(link) => link && (
                    <Button href={link} target="_blank" icon="link" />
                  )}
                />
              )}
              {months.map((month, index) =>
              <Column
                title={(
                  <small>
                    {month.text}
                    <Icon
                      type="delete"
                      style={{ cursor: 'pointer', marginLeft: 5 }}
                      onClick={() => handleDeleteMonth(month, index)}
                    />
                  </small>
                )}
                dataIndex={month.base}
                key={month.base}
                width={100}
                align="center"
                className="grid-month"
                render={(_, record) => {
                  const currentRegister = department !== 'IRPF' ?
                    record[`date${Number(month.base) - 1}`] :
                    record[`date${index}`];

                  const isWithPendency = record[`date${index}`] === 2;
                  const isEmailSent = record[`is_email_sent${index}`];
                  const isEmailViewed = record[`is_email_viewed${index}`];
                  const isWhatsappSent = record[`is_whatsapp_sent${index}`];
                  return(
                  <Dropdown overlay={
                    <Menu 
                      onClick={(event) => {
                        if (event.key === 'delete') {
                          return handleDelete({
                            id: record.id,
                            monthBase: month.base,
                            monthYear: month.year
                          });
                        }

                        changeStatus(department, {
                          status: event.key,
                          id: record.id,
                          month_base: month.base,
                          year
                        })
                      }}
                      >
                      <Menu.Item key="0"><Icon type="check" /> Sem pendência</Menu.Item>
                      <Menu.Item key="2"><Icon type="issues-close" />Com pendência</Menu.Item>
                      <Menu.Item key="1"><Icon type="check-circle" /> Completo</Menu.Item>
                      {currentRegister !== null && (
                        <Menu.Item key="delete"><Icon type="delete" /> Remover</Menu.Item>
                      )}
                    </Menu>
                  } trigger={['contextMenu','click']}>
                    <Tooltip 
                      placement="bottom"
                      title={get(record, `date${index}_user`) ? `Atualizado por: ${get(record, `date${index}_user`)} em ${moment(get(record, `date${index}_performed_at`)).subtract(3, 'hours').format('DD/MM/YYYY HH:mm:ss')}`:'Ainda não foi atualizado.'}>
                      <div style={{ 
                        userSelect: 'none',
                        backgroundColor: getBackgroundColorCell(get(record, `date${index}`)),
                        height: `100%`,
                        width: `100%`,
                        position: `absolute`,
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}>
                        {isWithPendency && (
                          <CellButtonsWrapper>
                            <CellButton
                              onClick={(event) => {
                                event.stopPropagation();
                                handleSendEmail({
                                  record,
                                  month,
                                  isEmailSent
                                })
                              }}
                            >
                              <Icon 
                                type="mail"
                                style={{ color: getEmailIconColor(isEmailSent, isEmailViewed) }}
                              />
                            </CellButton>
                            <CellButton
                              onClick={(event) => {
                                event.stopPropagation();
                                handleOpenWhatsapp({
                                  record,
                                  month,
                                  isWhatsappSent,
                                });
                              }}
                            >
                              <FaWhatsapp
                                size={16}
                                style={{
                                  color: getWhatsappIconColor(isWhatsappSent),
                                }}
                              />
                            </CellButton>
                          </CellButtonsWrapper>
                        )}
                    </div>
                    </Tooltip>
                  </Dropdown>
                )}
                }
              />
              )}
          </Table>
        </div>
        <EmailsLogsModal
          isOpen={emailsLogsModal.isOpen}
          data={emailsLogsModal.data}
          onClose={closeEmailsLogsModal}
          department={department}
        />
      </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
  data: state.malhaFina.data,
  isLoading: state.malhaFina.isLoading,
  findUser: (id) => state.users.filter(r=>r.id===id)[0],
});

const mapDispatchProps = dispatch => ({
  changeStatus: (department, data) => dispatch(malhaFinaActions.changeStatus(department, data)),
  deleteRegister: (department, data) => dispatch(malhaFinaActions.deleteRegister(department, data)),
  deleteAllRegisterOfMonth: (department, data) => dispatch(malhaFinaActions.deleteAllRegisterOfMonth(department, data)),
  sendWhatsapp: (department, data) => dispatch(malhaFinaActions.sendWhatsapp(department, data)),
  sendEmail: (department, data) => dispatch(malhaFinaActions.sendEmail(department, data)),
  sendEmailsInBatch: (department, data) => dispatch(malhaFinaActions.sendEmailsInBatch(department, data)),
});

export default connect(mapStateToProps, mapDispatchProps)(withRouter(List));